import axios from '@/libs/api.request';

export const getQualifyFailReportRecord = data => {
    return axios.request({
        url: 'web/qualifyFailReportManagement/getQualifyFailReportRecord',
        data: data,
        method: 'post'
    });
};

export const getQualifyFailReportDetail = qualifyFailReportRecordUuid => {
    return axios.request({
        url: 'web/qualifyFailReportManagement/getQualifyFailReportDetail',
        data: { qualifyFailReportRecordUuid },
        method: 'post'
    });
};

export const qualifyFailReportSeedFarmResponse = data => {
    return axios.request({
        url: 'api/qualifyFailReportManagement/qualifyFailReportSeedFarmResponse',
        data: data,
        method: 'post'
    });
};

export const qualifyFailReportMasterResponse = data => {
    return axios.request({
        url: 'api/qualifyFailReportManagement/qualifyFailReportMasterResponse',
        data: data,
        method: 'post'
    });
};

export const qualifyFailReportApplyDelayed = qualifyFailReportRecordUuid => {
    return axios.request({
        url: 'api/qualifyFailReportManagement/qualifyFailReportApplyDelayed',
        data: { qualifyFailReportRecordUuid },
        method: 'post'
    });
};

